import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Helmet } from 'react-helmet-async';
import { useMenu } from '../../hooks/useMenu';
import MetalStreamReviewData from './MetalStreamReviewData';
import Paragraph from '../../components/Paragraph/Paragraph';
import { Heading } from '../../components/Heading';
import OnBoardingContainer from '../../components/OnBoarding/OnBoardingContainer';
import OnBoardingCta from '../../components/OnBoarding/OnBoardingCta';
import useStepPost from '../../hooks/useStepPost';
import themeColors from '../../assets/styles/themeColors';
import { selectSettings } from '../../store/selectors/settingsSelectors';
import useGtmStepHook from '../../util/hooks/useGtmStepHook';
import { ACCOUNT_STEP_COMPLETE, ACCOUNT_STEP_VIEW } from '../../util/gtmEvents';
import { gtmStepHelper } from '../../util/helpers/gtmHelper';

const MetalStreamReview = () => {
  const { t } = useTranslation();
  const { BrokerName } = useSelector(selectSettings);

  const { activeMenu, activeItem } = useMenu();
  const { onSuccess } = useStepPost({ nextPath: activeItem?.nextPath });
  const { gtmStepEvent } = useGtmStepHook();

  useEffect(() => {
    gtmStepHelper({
      gtmStepEvent,
      eventName: ACCOUNT_STEP_COMPLETE,
      stepLabel: 'Fund your account',
    });

    gtmStepHelper({
      gtmStepEvent,
      eventName: ACCOUNT_STEP_VIEW,
      stepLabel: 'MetalStream Review',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGtmEvent = () => {
    gtmStepHelper({
      gtmStepEvent,
      eventName: ACCOUNT_STEP_COMPLETE,
      stepLabel: 'MetalStream Review',
    });
  };

  return (
    <OnBoardingContainer
      activeMenu={activeMenu}
      activeItem={activeItem}
      previousPath={activeItem?.previousPath}
    >
      <Helmet>
        <title>
          {t('metalstream.titleTagReview', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <Heading mb={12}>{t('metalstream.reviewTitle')}</Heading>
      <Paragraph mb={36} color={themeColors.colorTextXLLight}>
        {t('metalstream.reviewSubtitle')}
      </Paragraph>
      <MetalStreamReviewData />
      <OnBoardingCta
        title={t('Continue')}
        onClick={() => {
          onSuccess();
          handleGtmEvent();
        }}
      />
    </OnBoardingContainer>
  );
};

export default MetalStreamReview;
